import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { store } from 'reactApp/store';

class ViewerController {
    public isViewerActive = (): boolean => ViewerSelectors.isViewerActive(store.getState());
}

const viewerController = new ViewerController();

export { viewerController };
